


























































import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { Action, State, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr } from '@/store/campaign/types';
import { CurrentCampaignType } from '@/store/campaign/types';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms} from '@/const/terms/componentTerms';
import { EditCampaign as feedbackTerms } from '@/const/terms/feedback/campaign';

import { STATUS } from '@/const/status/index';
import { ID_TYPE, IAPP } from '@/const/types/index';
import {
    FormType,
    FormResponse,
    CategoryOptionResponseType,
    IMajorCategory,
    ISubCategory,
    SubCategoryOptionType,
} from './editingTypes';
import { InitialFormData } from './editingData';
import { AdvertiserDataType, IAdvertiser } from '@/pages/partner/legacy/types';

import { Form as ElForm} from 'element-ui';

import CampaignForm from '@/components/pages/campaign/CampaignForm.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import { AxiosError, AxiosResponse } from 'axios';

const campaignModule = namespace('Campaign');

@Component<CampaignEdit>({
    name: 'CampaignEdit',
    components: {
        CampaignForm,
    },
    beforeRouteLeave (to: any, from: any, next: any) {
        if (this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    }
})
export default class CampaignEdit extends Vue {
    private terms = terms;
    private compTerms = compTerms;

    private appOptions: SelectOptionType<IAPP>[] = [];
    // private partnerOptions: SelectOptionType[] = [];
    private advertiserOptions: SelectOptionType[] = [];
    private countryOptions: SelectOptionType[] = [];
    private majorCategoryOptions: SelectOptionType[] = [];
    private subCategoryOptions: SubCategoryOptionType[] = [];
    // private trackingOptions: SelectOptionType[] = [];
    
    private isSubmit: boolean = false; 
    private loading: boolean = false;
    private form: FormType = _.cloneDeep(InitialFormData);

    get whichLocation() {
        return this.$route.path.split('/').splice(-1, 1)[0].toLowerCase();
    }
    get isEdit() {
        return (this.$route.params && this.$route.params.campaignID && true) === true;
    }

    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign: any;
    @campaignModule.Action('CLEAR_CURRENT_CAMPAIGN') private clearCurrentCampaign: any;
    @campaignModule.State(state => state.currentCampaign) private currentCampaign!: CurrentCampaignType;

    get date() {
        if (this.form.date) {
            if (this.form.date[1] === '') return moment(this.form.date[0]).format('YYYY-MM-DD') + ' ~ 계속';
            return moment(this.form.date[0]).format('YYYY-MM-DD') + ' ~ ' + moment(this.form.date[1]).format('YYYY-MM-DD');
        }
    }
    get app() {
        if (this.form.app) {
            const app = this.appOptions.find((v: SelectOptionType<IAPP>) => v.value.key === (this.form.app as IAPP).key);
            if (app) {
                return app.label;
            }
        } 
        return '';
    }
    

    private cancel() {
        this.$router.push({name: 'campaign'});
    }
    private submitProcess() {
        const campaignForm = (this.$refs.campaignForm as CampaignForm);
        const form = (campaignForm.$refs.form as ElForm);
        form.validate().then((valid: boolean) => {
            if (valid) {
                this.loading = true;
                if (this.isEdit) {
                    this.submitForEditHandler(form);
                } else {
                    this.submitForNewHandler(form);
                }
            } else {
                return false;
            }
        }).catch((err: boolean) => {
            if (err === false) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;
                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;
                    el.focus();
                }
            }
        })
    }
    
    private submitForEditHandler(form: ElForm) {
        this.submitForEdit(form.model as FormType).then((res: any) => res.data)
            .then((res: {result: boolean, status?: number}) => {
                if (res && res.result) {
                    this.$notify.success(feedbackTerms.editing.success);
                    this.isSubmit = true;
                    this.$router.push({name: 'campaign'});
                    return;
                }
                if (res.hasOwnProperty('status')) { 
                    if (res.status === 2) { // 중복된 이름 에러
                        const errorField = (form as any).fields.find((f: any) => f.prop === 'name') as Vue;
                        if (errorField) {
                            const el = errorField.$el.querySelector('input') as HTMLElement;
                            el.focus();
                        }
                        throw new Error(feedbackTerms.editing.error.duplicatedName);
                        return;
                    } else if (res.status === 3) { // 중복된 커스텀 ID 에러
                        const errorField = (form as any).fields.find((f: any) => f.prop === 'customID') as Vue;
                        if (errorField) {
                            const el = errorField.$el.querySelector('input') as HTMLElement;
                            el.focus();
                        }
                        throw new Error(feedbackTerms.new.error.duplicatedCustomID)
                        return;
                    }
                }
                throw new Error(feedbackTerms.editing.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.editing.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            })
    }
    private submitForEdit(model: FormType){
        (!model.budget.limited) && (model.budget.value = 0);
        (!model.totalFrequency.isUsed) && (model.totalFrequency.whichUsed = 'impression', model.totalFrequency.impression = 0, model.totalFrequency.click = 0);
        (!model.dailyFrequency.isUsed) && (model.dailyFrequency.whichUsed = 'impression', model.dailyFrequency.impression = 0, model.dailyFrequency.click = 0);
        (!model.impressionInterval.isUsed) && (model.impressionInterval.value = 0);
        model.customID = (model.hasOwnProperty('customID') && model.customID && (model.customID as string).trim() !== '') ? (model.customID as string).trim() : null;

        return this.$http.adserverAPI.post('UpdateCampaignInfo', {
            id:         model.id,
            name:       model.name.trim(),
            app:        model.app,
            status:     model.status,
            impWeight:     model.impWeight,
            category:   model.category,
            budget:     model.budget,
            daily_equality: model.dailyEquality,
            partner:    model.partner,
            begin_date: model.date[0] ? (model.date[0] as Date).getTime() : null,
            end_date:   model.date[1] ? (model.date[1] as Date).getTime() : null,
            totalFrequency: model.totalFrequency,
            dailyFrequency: model.dailyFrequency,
            dailyEquality: model.dailyEquality,
            impressionInterval: model.impressionInterval,
            customID: model.customID,
        });
    }
    // private submitForEdit = (model: FormType) => Promise.resolve(true);
    private submitForNewHandler(form: ElForm) {
        this.submitForNew(form.model as FormType).then((res: any) => res.data)
            .then(async ({result, campaign_id, status}: {result: boolean, campaign_id: undefined | ID_TYPE, status?: number}) => {
                if (result) {
                    try {
                        await this.setCurrentCampaign({
                            id: campaign_id,
                            name: this.form.name,
                            app: (this.form.app as IAPP),
                        });
                        this.$notify.success(feedbackTerms.new.success);
                        this.isSubmit = true;
                        this.$router.push({
                            name: 'adsetNew',
                            params: { 
                                campaignID: this.currentCampaign.id.toString(),
                            },
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(feedbackTerms.new.error.setCurrentCampaign.message);
                                break;
                        }
                        throw new Error(feedbackTerms.new.error.fail);
                    }
                    return;
                }
                if (status !== undefined) {
                    if (status === 2) { // 이름 중복 에러
                        const errorField = (form as any).fields.find((f: any) => f.prop === 'name') as Vue;
                        if (errorField) {
                            const el = errorField.$el.querySelector('input') as HTMLElement;
                            el.focus();
                        }
                        throw new Error(feedbackTerms.new.error.duplicatedName)
                        return;
                    } else if (status === 3) { // 커스텀 ID 중복 에러
                        const errorField = (form as any).fields.find((f: any) => f.prop === 'customID') as Vue;
                        if (errorField) {
                            const el = errorField.$el.querySelector('input') as HTMLElement;
                            el.focus();
                        }
                        throw new Error(feedbackTerms.new.error.duplicatedCustomID)
                        return;
                    }
                }
                throw new Error(feedbackTerms.new.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.new.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            });
    }
    private submitForNew(model: FormType){
        (!model.budget.limited) && (model.budget.value = 0);
        (!model.totalFrequency.isUsed) && (model.totalFrequency.whichUsed = 'impression', model.totalFrequency.impression = 0, model.totalFrequency.click = 0);
        (!model.dailyFrequency.isUsed) && (model.dailyFrequency.whichUsed = 'impression', model.dailyFrequency.impression = 0, model.dailyFrequency.click = 0);
        (!model.impressionInterval.isUsed) && (model.impressionInterval.value = 0);
        model.customID = (model.hasOwnProperty('customID') && model.customID && (model.customID as string).trim() !== '') ? (model.customID as string).trim() : null;

        return this.$http.adserverAPI.post('CreateAdsvCampaign', {
            name:       model.name.trim(),
            app:        model.app,
            status:     model.status,
            impWeight:     model.impWeight,
            category:   model.category,
            budget:     model.budget,
            partner:    model.partner,
            begin_date: model.date[0] ? (model.date[0] as Date).getTime() : null,
            end_date:   model.date[1] ? (model.date[1] as Date).getTime() : null,
            totalFrequency: model.totalFrequency,
            dailyFrequency: model.dailyFrequency,
            dailyEquality: model.dailyEquality,
            impressionInterval: model.impressionInterval,
            customID: model.customID,
        });
    }
    // private submitForNew = (model: FormType) => Promise.resolve(true);

    private initOptionData() {
        this.appOptionData().then((res: any) => res.data)
            .then((data: IAPP[]) => {
                this.appOptions = data.map((item: IAPP) => (
                    {label: item.name, value: item}
                ))
                    .sort((a: SelectOptionType<IAPP>, b: SelectOptionType<IAPP>) => a.label < b.label ? -1 : 1);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.editing.error.getResponse);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })

        this.categoryOptionData().then((res: any) => res.data)
            .then((data: CategoryOptionResponseType) => {
                this.majorCategoryOptions = data.divisions.map((item: IMajorCategory) => (
                    {label: item.name, value: item.code}
                ))
                    .sort((a: SelectOptionType, b: SelectOptionType) => a.label < b.label ? -1 : 1);

                this.subCategoryOptions = data.sections.map((item: ISubCategory) => (
                    {label: item.name, value: item.code, divisionCode: item.division_code}
                )) 
                    .sort((a: SubCategoryOptionType, b: SubCategoryOptionType) => a.label < b.label ? -1 : 1);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.editing.error.getResponse);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
        this.advertiserOptionData().then((res: any) => res.data)
            .then((data: AdvertiserDataType) => {
                this.advertiserOptions = data.map((item: IAdvertiser) => (
                    {label: item.name, value: item.no}
                ))
                    .sort((a: SelectOptionType, b: SelectOptionType) => a.label < b.label ? -1 : 1);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.editing.error.getResponse);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
    }


    private getCampaignData(campaignID: ID_TYPE){
        return this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID});
    }

    private appOptionData() {
        return this.$http.adserverAPI.post('GetSSPAppList', {inventory: false});
    }
    private advertiserOptionData() {
        return this.$http.adserverAPI.post('GetAdvCompanyList');
    }
    private categoryOptionData() {
        return this.$http.adserverAPI.post('GetCategoryList');
    }

    private async created() {
        this.initOptionData();

        if (this.isEdit) { // 수정
            this.loading = true;
            await this.getCampaignData(this.$route.params.campaignID).then((res: any) => res.data)
                .then(async (data: FormResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(feedbackTerms.editing.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app:    data.app as IAPP,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(feedbackTerms.new.error.setCurrentCampaign.message);
                                break;
                        }
                        throw new Error(feedbackTerms.new.error.fail);
                    }
                    
                    this.form.id        = data.id;
                    this.form.customID  = data.customID;
                    this.form.category  = data.category;
                    this.form.name      = data.name;
                    this.form.status    = data.status;
                    this.form.app       = data.app;
                    this.form.budget    = data.budget;
                    this.form.date      = [data.beginDate ? new Date(data.beginDate) : '', data.endDate ? new Date(data.endDate) : ''];
                    this.form.partner   = data.partner;
                    data.totalFrequency.isUsed      && (this.form.totalFrequency        = data.totalFrequency);
                    data.dailyFrequency.isUsed      && (this.form.dailyFrequency        = data.dailyFrequency);
                    data.impressionInterval.isUsed  && (this.form.impressionInterval    = data.impressionInterval);
                    this.form.dailyEquality = data.dailyEquality;
                    this.form.impWeight     = data.impWeight;
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.editing.error.getResponse);
                    } else {
                        this.$notify.error(err.message);
                        this.isSubmit = true;
                        this.$router.push({name: 'campaign'});
                    }
                    throw err;
                })
                .finally(()=>{
                    this.loading = false;
                })
        } else {
            try {
                await this.clearCurrentCampaign()
            } catch (err) {
                switch (err.type) {
                    case campaignStoreErr.CLEAR_CURRENT_CAMPAIGN:
                        this.$notify.error({
                            title: feedbackTerms.new.error.clearCurrentCampaign.title,
                            message: feedbackTerms.new.error.clearCurrentCampaign.message,
                        });
                        this.isSubmit = true;
                        this.$router.push({name: 'campaign'});
                        break;
                }
            }
        }
    }
}
